// @aide-description Filterable list of sites with their status, size, and group and user counts, where sites are created, activated, deactivated and deleted
import React from "react";
import { MaplesPage } from "components/pages";
import { ListSites } from "features/Sites/ListSites";

const SitesListPage = () => {
  return (
    <MaplesPage headerItems={["Sites"]}>
      <ListSites />
    </MaplesPage>
  );
};

export default SitesListPage;
